export const getChartData = ({
  conclusionsPro,
  proCalculationCharts,
  calculation,
  activePosition,
}: {
  conclusionsPro: any;
  proCalculationCharts: any;
  calculation: any;
  activePosition: 10 | 20 | 30;
}) => {
  const earlySaleProfit =
    proCalculationCharts?.investmetAnalysisChart?.earlySaleProfit?.[
      activePosition
    ];
  const rentalYield =
    calculation?.rentalYields?.investmentObjectRentalYield?.rentalYield * 100;
  const irr =
    calculation?.investmetAnalysis?.irrByYearCombinedLoan?.[activePosition];
  const roi =
    calculation?.investmetAnalysis?.roiByYearCombinedLoan?.[activePosition];
  const investmentsAcc =
    proCalculationCharts?.investmentAccChart?.investmentAcc?.[activePosition];
  const investorCashFlowAverage =
    proCalculationCharts?.taxSavingsAndProfitChart
      ?.investorCashFlowByYearAverage?.[activePosition];
  const specialLoan =
    proCalculationCharts?.loansChart?.info?.loans?.[1]?.amount;
  const totalTaxSavings =
    proCalculationCharts?.taxSavingsChart?.totalTaxSavings?.[activePosition];
  const userScenarioResult = conclusionsPro?.userScenarioResult;
  const rentalYieldVariant =
    calculation?.rentalYields?.investmentObjectRentalYield.conclusionVariant;

  return {
    earlySaleProfit,
    rentalYield,
    irr,
    roi,
    investmentsAcc,
    investorCashFlowAverage,
    specialLoan,
    totalTaxSavings,
    userScenarioResult,
    rentalYieldVariant,
  };
};
